<template>
  <div class="container">
    <div ref="carousel" class="owl-carousel owl-theme">
      <div class="wrpaBox" data-merge="1">
        <div class="video-desc swiper-desc fade-transform-leave-active fade-transform-enter-active" >
          <div class="video-wenan">
            <!-- <div class="renderg-text">
              <img src="../../assets/image/renderg-text1.png" alt="">
            </div> -->
            <p class="video-desc1 mb15">
              <img src="../../assets/image/RenderG.png" alt="">
            </p>
            <p class="client-desc2 mb20">
              <span class="client-active">助力</span>
              <span>艺术家从容工作</span>
            </p>
            <p class="client-desc3">您身边的渲染专家</p>
          </div>
        </div>
        <video  
          v-if="maxScroll"
          ref="videoPlayer"
          id="videoTime"
          preload="none" 
          poster="../../assets/image/loadimg/video-bg.jpg"
          muted
          autoplay
          playsinline>
          <!-- <source type="video/mp4" src="../../assets/video/cpu.mp4"> -->
          <source type="video/webm" :src="base_image_url + '/cpu.webm'">
        </video>
        <video  
          v-if="mdScroll"
          ref="videoPlayer"
          id="videoTime"
          preload="none" 
          poster="../../assets/image/loadimg/video-bg-md.jpg"
          muted
          autoplay
          playsinline>
          <!-- <source type="video/mp4" src="../../assets/video/cpu_md.mp4"> -->
          <source type="video/webm" :src="base_image_url + '/cpu_md.webm'">
        </video>
        <video  
          v-if="smScroll"
          ref="videoPlayer"
          id="videoTime"
          preload="none" 
          poster="../../assets/image/loadimg/video-bg-sm.jpg"
          muted
          autoplay
          playsinline>
          <!-- <source type="video/mp4" src="../../assets/video/cpu_sm.mp4"> -->
          <source type="video/webm" :src="base_image_url + '/cpu_sm.webm'">
        </video>
        <video  
          v-if="xsScroll"
          ref="videoPlayer"
          id="videoTime"
          preload="none" 
          poster="../../assets/image/loadimg/video-bg-xs.jpg"
          muted
          autoplay
          playsinline>
          <!-- <source type="video/mp4" src="../../assets/video/cpu_xs.mp4"> -->
          <source type="video/webm" :src="base_image_url + '/cpu_xs.webm'">
        </video>
      </div>
      <div class="owl-carousel-item">
        <div class="swiper-img-box">
          <div class="flex-center swiper-box-desc fade-transform-leave-active fade-transform-enter-active">
            <div class="client-desc">
              <p class="client-desc1 mb15"> PC客户端</p>
              <p class="client-desc2 mb20">
                <span class="client-active">轻便</span>
                <span> 易用</span>
                <span class="client-active"> 专业</span>
              </p>
              <p class="client-desc3"> 智能分析上传用户资产</p>
            </div>
          </div>
          <div class="swiper-img">
            <img 
              class="hidden-xs-only"
              :src="base_image_url + '/images/swiper2.png'" 
              alt />
            <img 
              class="hidden-sm-and-up"
              :src="base_image_url + '/images/swiper2-375.png'" 
              alt />
          </div>
        </div>
      </div>
      <div class="owl-carousel-item">
        <div class="swiper-img-box">
          <div class="flex-center swiper-box-desc fade-transform-leave-active fade-transform-enter-active">
            <div class="client-desc">
              <p class="web-desc1">跨平台</p>
              <p class="web-desc2">实时跟踪任务状态</p>
              <p class="web-desc3">WEB 移动端</p>
            </div>
          </div>
          <div class="swiper-img">
            <img 
              class="hidden-xs-only"
              :src="base_image_url + '/images/swiper1.png'" 
              alt />
            <img 
              class="hidden-sm-and-up"
              :src="base_image_url + '/images/swiper1-375.png'" 
              alt />
          </div>
        </div>
      </div>
    </div>
    <FastRegister></FastRegister>
  </div>
</template>

<script>
import { base_image_url } from '@/constants/baseUrl'
import FastRegister from '../register/index'
export default {
  name: 'swiperBox',
  components: {
    FastRegister
  },
  data() {
    return {
      autoplay: false,
      maxScroll: false,
      mdScroll: false,
      smScroll: false,
      xsScroll: false,
      phone: '',
      style: {
        height: '100vh'
      }
    }
  },
  created() {
    if (document.body.clientWidth > 1200 ) {
      this.maxScroll = true
    } else if (document.body.clientWidth >= 992 && document.body.clientWidth < 1200) {
      this.mdScroll = true
    } else if (document.body.clientWidth >= 768 && document.body.clientWidth < 992) {
      this.smScroll = true
    } else if (document.body.clientWidth < 768) {
      this.xsScroll = true
    }
  },
  computed: {
    base_image_url() {
      return base_image_url
    }
  },
  mounted () {
    var owl = $('.owl-carousel');
    let _this = this
    this.$nextTick(() => {
      owl.owlCarousel({
        items: 1,
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        singleItem:true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
      });  
      // console.log('owlCarousel', owl.owlCarousel)
      owl.on('changed.owl.carousel', function(event) {
          if (event.item.index == 2) {
            _this.playVideo()
            owl.trigger('stop.owl.autoplay')
          }
      })
    })
    this.listenVideo()
  },
  methods: { 
    // 监听视频的播放暂停播放完毕等事件
    listenVideo () {
      let myVideo = this.$refs.videoPlayer
      var owl = $('.owl-carousel')
      // 监听播放
      myVideo.addEventListener('play', () => {
        this.autoplay = false;
      })
      // 监听暂停
       myVideo.addEventListener("pause",()=>{
          this.autoplay = true;
      });
      // 监听播放完毕
      myVideo.addEventListener('ended', () => {
        this.autoplay = true;
        owl.trigger('next.owl.carousel')
        owl.trigger('play.owl.autoplay')
        myVideo.currentTime = 0;
      })
    },
    // 视频播放
    playVideo () {
      let myVideo = this.$refs.videoPlayer
      myVideo.play()
    },
    // 立即注册
    registerClick () {
      if (this.phone) {
        window.location.href = 'https://v.renderg.com/#/register?flag=register&phone='+this.phone
      } else {
        window.location.href = 'https://v.renderg.com/#/register?flag=register'
      }
    }
  },
}
</script>